



























import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import {
  QueryReferralRecord,
  ReceivePatient,
  ReceivePatientBatch
} from "@/api/pdReferral";
import PdReturnPatient from "./return.vue";

/**
 * 患者接收
 */
@Component({
  components: {
    PdReturnPatient
  }
})
export default class PdReceive extends AbpBase {
  data: any = [];
  showReturn: boolean = false;
  loading: boolean = false;
  tableTotalSize: number = 0;
  currentPatient: any = {};
  queryCondition: any = {
    QueryString: "",
    SkipCount: 1,
    MaxResultCount: 10,
    targetCommunityId: 0,
    state: -1
  };
  columns = [
    {
      type: "selection",
      width: 60,
      fixed: "left",
      align: "center"
    },
    {
      title: "患者姓名",
      width: 120,
      fixed: "left",
      key: "patientName"
    },
    {
      title: "身份证号",
      width: 200,
      key: "cid"
    },
    {
      title: "推送时间",
      width: 170,
      key: "referralTime",
      render: (h: any, p: any) => {
        return h(
          "span",
          {},
          this.fmtDate(new Date(p.row.referralTime), "yyyy-MM-dd hh:mm")
        );
      }
    },
    {
      title: "推送人",
      width: 100,
      key: "referralUserName"
    },
    {
      title: "目标团队",
      width: 120,
      key: "targetTeamName"
    },
    {
      title: "目标医生",
      width: 120,
      key: "targetDoctorName"
    },
    {
      title: "原社区",
      width: 200,
      ellipsis: true,
      tooltip: true,
      key: "sourceCommunityName"
    },
    {
      title: "状态",
      width: 120,
      key: "referralStatusName"
    },
    {
      title: "推送原因",
      ellipsis: true,
      tooltip: true,
      minWidth: 120,
      key: "referralReason"
    },
    {
      key: "",
      width: 150,
      title: "操作",
      fixed: "right",
      render: (h: any, p: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: { type: "success", size: "small" },
              style: { marginRight: "10px" },
              on: {
                click: () => {
                  this.handleReceive(p.row);
                }
              }
            },
            "接收"
          ),
          h(
            "Button",
            {
              props: { type: "error", size: "small" },
              on: {
                click: () => {
                  this.handleBack(p.row);
                }
              }
            },
            "退回"
          )
        ]);
      }
    }
  ];

  pageChange(val: any) {
    this.queryCondition.SkipCount = val;
    this.getData();
  }

  async getData() {
    this.loading = true;
    let res = await QueryReferralRecord(this.queryCondition);
    this.data = res.items;
    this.tableTotalSize = res.totalCount;
    this.$emit("refresh-receive-count", this.tableTotalSize);
    this.loading = false;
  }

  //接收
  async handleReceive(row: any) {
    await ReceivePatient(row);
    this.getData();
  }

  //退回
  handleBack(row: any) {
    this.$confirm("确定要退回此患者吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(() => {
      this.currentPatient = row;
      this.showReturn = true;
    });
  }

  async handleReturnSubmit() {
    let res = await this.$refs["PdReturnPatient"].submit();
    if (res) {
      this.showReturn = false;
      this.getData();
    }
  }

  async handleReceiveBatch() {
    let list = this.$refs.table1.getSelection();
    if (list.length == 0) {
      this.$Message.error("请选择要接收的患者");
      return;
    }

    await ReceivePatientBatch({ recordList: list });
    this.getData();
  }

  created() {
    if (this.$store.state.session.user) {
      this.queryCondition.referralStatus = "Dic_ReferralStatus_001";
      this.queryCondition.targetCommunityId = this.$store.state.session.user.communityId;
      this.getData();
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdReferral/pdReceive/index.vue